import React, { useState } from "react";
import "../../styles/CostValue.css";
import dashboardImg from "../../assets/ManageMultiple_Dashboard.jpg";
import supportImg from "../../assets/Integrated_Ai_Customer.png";
import messagingImg from "../../assets/costValue.png";
import minimalImg from "../../assets/Minimal_Hardware.jpg";
import simplerPaymentsImg from "../../assets/Simple_Payments.png";
import FancyGetStartedButton from "./FancyGetStartedButton";
import GlowButton from "./GlowButton";

const CostValue = () => {

    const [isMouseOver, setIsMouseOver]=useState(false);

  return (
    <section className="cost-value-hero mb-[-5rem] sm:mb-[-3rem] md:mb-[-4rem]" aria-labelledby="costvalue-heading">
      {/* Header Section */}
      <div className="cv-container">
        <h2 id="costvalue-heading" className="cv-title text-[38px] md:text-[40px] lg-xl:text-[30px] xl-2xl:text-[50px] sm:leading-[35px]">
          <span className="cv-highlight ">cost & value</span> you’ll love
        </h2>

        <h3 className="cv-subtitle text-[38px] md:text-[40px] lg-xl:text-[30px] xl-2xl:text-[40px] sm:leading-[35px] md:leading-[10px] lg-xl:leading-[13px] xl-2xl:leading-[15px]">
          first month free, cancel anytime, no risk
        </h3>

        <p className="cv-lead">
          get a closer look at how beɘmz transforms your operations and customer
          experience. watch our demo video to see real-time ordering, ai
          support, and seamless service in action — built to help your business
          grow faster and smarter.
        </p>
      </div>

      {/* Content Grid */}
      <div className="content-grid">
        {/* Large Card */}
        <div className="content-card large-card sm:mb-10 md:mb-10">
          <img src={dashboardImg} alt="Dashboard" className="responsive-img" />
          <h4 className="text-[20px] md:text-[22px] lg-xl:text-[23px] xl-2xl:text-[25px]">manage multiple business locations from one dashboard</h4>
          <ul className="text-[16px]">
            <li>easily manage your team</li>
            <li>take orders and payments</li>
            <li>interact with your customers</li>
            <li>even create and edit your menu's</li>
            <li>catalogs, inventory</li>
            <li>social marketing content</li>
            <li>improve customer retention</li>
            <li>increase revenue 3%-5%</li>
            <li>reduce cost by 30%</li>
          </ul>

          {/* <FancyGetStartedButton  onMouseOver={()=>setIsMouseOver(true)} onMouseOut={()=>setIsMouseOver(false)} isMouseOver={isMouseOver}/> */}
          <div className="mt-0 sm:mt-10 flex flex-wrap justify-center items-center gap-4">
            <span><GlowButton btnValue="free trial" btn1="2" onMouseOver={()=>setIsMouseOver(true)} onMouseOut={()=>setIsMouseOver(false)} isMouseOver={isMouseOver} onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
          </div>
        </div>

        {/* Column 1 */}
        <div className="content-card small-card sm:mb-10 md:mb-10">
          <img
            src={supportImg}
            alt="Customer Support"
            className="responsive-img"
          />
          <h2 className="sm:text-[16px] md:text-[18px] ">integrated ai customer support</h2>
          <p className="sm:text-[13px] md:text-[16px] ">
            always give your customers a vip experience. let beɘmz ai take
            orders and manage enquiries during peak or off-peak times
          </p>
        </div>

        {/* Column 2 */}
        <div className="content-card small-card sm:mb-10 md:mb-10">
          <img
            src={messagingImg}
            alt="Messaging and Marketing"
            className="responsive-img"
          />
          <h2 className="sm:text-[16px] md:text-[18px] ">deepen customer connections with beɘmz messaging and marketing</h2>
            <p className="sm:text-[13px] md:text-[16px] ">
            keep your customers returning and gain competitive advantage using beɘmz
            location-based chat, fast marketing, and social media
          </p>
        </div>

        {/* Column 3 */}
        <div className="content-card small-card sm:mb-10 md:mb-10">
          <img
            src={minimalImg}
            alt="Minimal Hardware"
            className="responsive-img"
          />
          <h2 className="sm:text-[16px] md:text-[18px]">minimal hardware works on ios, android, and web</h2>
            <p className="sm:text-[13px] md:text-[16px] ">
            no additional license or pos hardware costs. beɘmz works on mobiles,
            tablets and monitors. kitchen/back office order display included!
            every customer has your menu and pos for quick easy payments - no
            bottlenecks
          </p>
        </div>

        {/* Column 4 */}
        <div className="content-card small-card sm:mb-10 md:mb-10">
          <img
            src={simplerPaymentsImg}
            alt="Simple Payments"
            className="responsive-img"
          />
          <h2 className="sm:text-[16px] md:text-[18px] ">simple payments: upfront, group or split with q management</h2>
            <p className="sm:text-[13px] md:text-[16px] ">
            easy payments processed in-app or via 3'rd parties, through our in
            chat ordering with q and order management per hour. plus simple
            cancellation and refund processing with receipts etc...
          </p>
        </div>
      </div>
    </section>
  );
};

export default CostValue;
